// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Timestamp$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";
import * as DeccoUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";
import * as DriverPaymentHistoryAPIModel from "../api-model/DriverPaymentHistoryAPIModel.bs.js";

function apiModelToState(res) {
  return {
          payment_history: List.map((function (model) {
                  return {
                          amount: model.amount,
                          status: model.status,
                          lead_id: model.lead_id,
                          transaction_id: model.transaction_id,
                          created_at: Timestamp$Catalyst.make(model.created_at),
                          updated_at: Timestamp$Catalyst.make(model.updated_at)
                        };
                }), res.payment_history)
        };
}

function execute(json) {
  return apiModelToState(DeccoUtils$Catalyst.resolveResult(DriverPaymentHistoryAPIModel.t_decode(json), "DriverPaymentHistoryEntityMapper.res"));
}

export {
  apiModelToState ,
  execute ,
  
}
/* Timestamp-Catalyst Not a pure module */
